import { Injectable } from '@angular/core';
import { Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class HttpUtilService {

 private API_URL: string = 'https://api.clinicacaesegatos.com/v1/public/';

    /* =================== */

    url(path: string) {
        return this.API_URL + path;
    }

    dataExtract(response: Response) {
		let data = response.json();
        return data || {};
    }

    error(erro: any) {
        return Observable.throw('Erro acessando servidor remoto.');
    }
}



// WEBPACK FOOTER //
// /Users/henriquezanini/Sites/Cães e Gatos/site/src/app/config/http-util.service.ts